import { render, staticRenderFns } from "./PMTable.vue?vue&type=template&id=2b8ea43a&"
import script from "./PMTable.vue?vue&type=script&lang=ts&"
export * from "./PMTable.vue?vue&type=script&lang=ts&"
import style0 from "./PMTable.vue?vue&type=style&index=0&id=2b8ea43a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports